var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100", attrs: { id: "form-search-popover" } },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          staticStyle: {
            "padding-bottom": "0 !important",
            "padding-top": "15px !important",
            height: "110px"
          }
        },
        [
          _c("div", { staticClass: "d-flex apps" }, [
            _c("img", {
              staticClass: "back-to-list-apps",
              attrs: { src: require("@/assets/icon/arrow-left.svg") },
              on: {
                click: function($event) {
                  _vm.$router.push("/setting/application")
                }
              }
            }),
            _vm._v(" "),
            _vm.modeDetail === "application" && _vm.urlIcon
              ? _c("img", {
                  staticClass: "m__r--5",
                  attrs: { src: _vm.urlIcon, width: "25" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.modeDetail === "application"
              ? _c("div", { staticClass: "title-apps" }, [
                  _vm._v("\n        " + _vm._s(_vm.application.appName) + " "),
                  _c("br")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.modeDetail === "group"
              ? _c("div", { staticClass: "title-apps m__t--3" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.dataGroup ? _vm.dataGroup.name : "") +
                      " "
                  ),
                  _c("br")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex",
              class: _vm.modeDetail === "group" ? "m__t--35" : "m__t--37"
            },
            [
              _c(
                "div",
                {
                  staticClass: "tab-experience-manager m__r--35",
                  class: {
                    "tab-experience-manager-active":
                      _vm.tabSelected === "general"
                  },
                  on: {
                    click: function($event) {
                      _vm.selectTab("general")
                    }
                  }
                },
                [_vm._v("\n        GENERAL\n      ")]
              ),
              _vm._v(" "),
              _vm.modeDetail === "application" && _vm.typeMode === "native"
                ? _c(
                    "div",
                    {
                      staticClass: "tab-experience-manager",
                      class: {
                        "tab-experience-manager-active":
                          _vm.tabSelected === "pages"
                      },
                      on: {
                        click: function($event) {
                          _vm.selectTab("pages")
                        }
                      }
                    },
                    [_vm._v("\n        PAGES\n      ")]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.tabSelected === "general" && _vm.modeDetail === "application"
        ? _c(
            "div",
            { staticClass: "studio-page-content" },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "11" } }, [
                    _c(
                      "div",
                      { staticClass: "card-field-container" },
                      [
                        _c("h4", [_vm._v("GENERAL")]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "form-edit" },
                          [
                            _c("b-col", { attrs: { cols: "4" } }, [
                              _c(
                                "div",
                                { staticClass: "bordered-app-detail" },
                                [
                                  _c("h4", [_vm._v("Icon")]),
                                  _vm._v(" "),
                                  _c("j-upload", {
                                    staticClass: "upload-blank-application",
                                    attrs: {
                                      "accepted-file-type": [
                                        "jpg",
                                        "png",
                                        "jpeg",
                                        "bmp",
                                        "xlsx",
                                        "docx"
                                      ],
                                      "api-token": _vm.api,
                                      "grid-cols": 12,
                                      "label-name":
                                        "Image that represents an application ",
                                      "img-default": _vm.urlIcon,
                                      "url-upload": _vm.url_upload
                                    },
                                    on: { url: _vm.getIcon }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "8" } }, [
                              _c(
                                "div",
                                { staticClass: "bordered-app-detail" },
                                [
                                  _c("h4", [_vm._v("General Information")]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.application.appName.$error
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "appName" } },
                                        [_vm._v(" Application Name ")]
                                      ),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          id: "appName",
                                          placeholder:
                                            "Enter application name here"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.application.appName.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.application.appName,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.application.appName.$model"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.typeMode === "hyperlink",
                                          expression: "typeMode === 'hyperlink'"
                                        }
                                      ],
                                      class: {
                                        "error-input":
                                          _vm.$v.application.appUrl.$error
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "appUrl" } },
                                        [_vm._v(" Url ")]
                                      ),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          id: "appUrl",
                                          placeholder: "Enter url"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.application.appUrl.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.application.appUrl,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.application.appUrl.$model"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.application.descName.$error
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "descName" } },
                                        [_vm._v(" Description ")]
                                      ),
                                      _vm._v(" "),
                                      _c("j-textarea", {
                                        attrs: {
                                          id: "descName",
                                          disabled: false,
                                          placeholder:
                                            "Enter application description here"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.application.descName.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.application.descName,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.application.descName.$model"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("label", [
                                        _vm._v(" Group Application ")
                                      ]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          options: _vm.groupOptions,
                                          placeholder: "Select Group",
                                          "value-format": "object"
                                        },
                                        model: {
                                          value: _vm.selectedGroup,
                                          callback: function($$v) {
                                            _vm.selectedGroup = $$v
                                          },
                                          expression: "selectedGroup"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.typeMode === "hyperlink",
                                          expression: "typeMode === 'hyperlink'"
                                        }
                                      ]
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          " Open Hyperlink in App Browser (Mobile) "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("j-toggle", {
                                        model: {
                                          value:
                                            _vm.$v.application
                                              .open_hyperlink_in_app_browser
                                              .$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.application
                                                .open_hyperlink_in_app_browser,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.application.open_hyperlink_in_app_browser.$model"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.typeMode === "hyperlink",
                                          expression: "typeMode === 'hyperlink'"
                                        }
                                      ]
                                    },
                                    [
                                      _c("label", [_vm._v(" Use Token ")]),
                                      _vm._v(" "),
                                      _c("j-toggle", {
                                        model: {
                                          value:
                                            _vm.$v.application.useToken.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.application.useToken,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.application.useToken.$model"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.application.is_offline_mode
                                    ? _c(
                                        "div",
                                        { staticClass: "local-storage" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/logo/offline-mode.png"),
                                              height: "16"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  Local Storage Support\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.typeMode === "native",
                                      expression: "typeMode === 'native'"
                                    }
                                  ],
                                  staticClass: "bordered-app-detail m__t--10"
                                },
                                [
                                  _c("h4", [_vm._v("Search Menu")]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "A search bar or search box in order to look up menu or page"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("j-toggle", {
                                    staticClass: "toggle-search-menu",
                                    model: {
                                      value: _vm.application.search_menu,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.application,
                                          "search_menu",
                                          $$v
                                        )
                                      },
                                      expression: "application.search_menu"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-right m__t--20" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btn blue",
                                on: { click: _vm.updateGeneral }
                              },
                              [_vm._v("\n              Update\n            ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabSelected === "pages" && _vm.showContainerPages
        ? _c("div", { staticClass: "studio-page-content d-flex" }, [
            _c(
              "div",
              {
                staticClass: "content-left-pages-studio-apps",
                attrs: { id: "sidebar-app" }
              },
              [
                _c("div", { staticClass: "head-pages" }, [_vm._v("Sidebar")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "list-pages" },
                  [
                    _vm._l(_vm.isParent, function(valParent) {
                      return _c(
                        "div",
                        { key: valParent.id, staticClass: "row-pages" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "row-pages-inner d-flex",
                              class: {
                                "pages-active":
                                  _vm.selectedPage &&
                                  _vm.selectedPage.id === valParent.id
                              },
                              on: {
                                click: function($event) {
                                  _vm.showComponentPages(valParent)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    _vm.selectedPage &&
                                    _vm.selectedPage.id === valParent.id
                                      ? valParent.icon_active
                                      : valParent.icon_white,
                                  height: "16",
                                  width: "16"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "m__l--15" }, [
                                _vm._v(_vm._s(valParent.name.toUpperCase()))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.getSubPageByParent(valParent.id), function(
                            valChild
                          ) {
                            return _c(
                              "div",
                              {
                                key: valChild.id,
                                staticClass: "row-pages-child",
                                class: {
                                  "pages-active":
                                    _vm.selectedPage &&
                                    _vm.selectedPage.id === valChild.id
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex",
                                    on: {
                                      click: function($event) {
                                        _vm.showComponentPages(valChild)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          _vm.selectedPage &&
                                          _vm.selectedPage.id === valChild.id
                                            ? valChild.icon_active
                                            : valChild.icon_white,
                                        height: "16",
                                        width: "16"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "m__l--15" }, [
                                      _vm._v(
                                        _vm._s(valChild.name.toUpperCase())
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          valParent.type === "menu" && !_vm.isFormActive
                            ? _c(
                                "div",
                                {
                                  staticClass: "m__t--10 m__b--10",
                                  on: {
                                    click: function($event) {
                                      _vm.createSubPage(valParent.id)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "row-pages-child",
                                      attrs: {
                                        id: "pageCreateSub-" + valParent.id
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-plus" }),
                                      _vm._v(
                                        "\n              Add Submenu\n            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-popover",
                            {
                              attrs: {
                                target: "pageCreateSub-" + valParent.id,
                                triggers: "manual",
                                placement: "bottom",
                                container: "sidebar-app"
                              }
                            },
                            [
                              _c("h3", [_vm._v("Add Sub Menu")]),
                              _vm._v(" "),
                              _c("j-form-page", {
                                ref: "formSubPage-" + valParent.id,
                                refInFor: true,
                                attrs: {
                                  "is-popover": true,
                                  mode: "createSub",
                                  "icon-options": _vm.iconOptions
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex justify-content-end mt-3"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn-border mr-2",
                                      on: { click: _vm.closeCreateSubPage }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Close\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn-blue",
                                      on: {
                                        click: function($event) {
                                          _vm.savePage(valParent.id)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Save\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "m__t--10 m__b--10",
                        on: { click: _vm.createParentPage }
                      },
                      [_vm._m(1)]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "b-popover",
                  {
                    attrs: {
                      target: "pageCreate",
                      triggers: "manual",
                      placement: "bottom",
                      container: "sidebar-app"
                    }
                  },
                  [
                    _c("h3", [_vm._v("Add Menu")]),
                    _vm._v(" "),
                    _c("j-form-page", {
                      ref: "formPage",
                      attrs: {
                        "is-popover": true,
                        "icon-options": _vm.iconOptions
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end mt-3" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn-border mr-2",
                            on: { click: _vm.closeCreateParentPage }
                          },
                          [_vm._v("\n            Close\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-blue",
                            on: {
                              click: function($event) {
                                _vm.savePage()
                              }
                            }
                          },
                          [_vm._v("\n            Save\n          ")]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content-right-pages-studio-apps" },
              [
                _vm.showComponent
                  ? _c("j-pages-setting", {
                      attrs: { "data-page": _vm.selectedPage },
                      on: { reload: _vm.getApplicationDetail }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.tabSelected === "pages" && !_vm.showContainerPages
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              staticStyle: { height: "400px" }
            },
            [_vm._m(2)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabSelected === "general" && _vm.modeDetail === "group"
        ? _c(
            "div",
            { staticClass: "studio-page-content" },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "10" } }, [
                    _c(
                      "div",
                      { staticClass: "card-field-container" },
                      [
                        _c("h4", [_vm._v("Properties")]),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            class: { "error-input": _vm.$v.group.name.$error }
                          },
                          [
                            _c("label", [_vm._v(" Group Name ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: { placeholder: "Enter group name here" },
                              model: {
                                value: _vm.$v.group.name.$model,
                                callback: function($$v) {
                                  _vm.$set(_vm.$v.group.name, "$model", $$v)
                                },
                                expression: "$v.group.name.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            class: {
                              "error-input": _vm.$v.group.description.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Description ")]),
                            _vm._v(" "),
                            _c("j-textarea", {
                              attrs: {
                                disabled: false,
                                placeholder: "Enter group description here"
                              },
                              model: {
                                value: _vm.$v.group.description.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.group.description,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression: "$v.group.description.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn blue",
                            on: { click: _vm.updateGeneral }
                          },
                          [_vm._v("\n            Update\n          ")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "10" } }, [
                    _c(
                      "div",
                      { staticClass: "card-field-container" },
                      [
                        _c("h4", [_vm._v("Application")]),
                        _vm._v(" "),
                        _c(
                          "v-client-table",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.load_first,
                                expression: "load_first"
                              }
                            ],
                            staticClass: "jTable group-application-table",
                            attrs: {
                              data: _vm.data_apps,
                              columns: _vm.columns,
                              options: _vm.table_options
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "id",
                                fn: function(props) {
                                  return _c("div", {}, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(props.row.id) +
                                        "\n            "
                                    )
                                  ])
                                }
                              },
                              {
                                key: "icon",
                                fn: function(props) {
                                  return _c("div", {}, [
                                    props.row.icon
                                      ? _c("img", {
                                          attrs: {
                                            src: props.row.icon,
                                            width: "32"
                                          }
                                        })
                                      : _vm._e()
                                  ])
                                }
                              },
                              {
                                key: "name",
                                fn: function(props) {
                                  return _c("div", {}, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(props.row.name) +
                                        "\n            "
                                    )
                                  ])
                                }
                              },
                              {
                                key: "delete",
                                fn: function(props) {
                                  return _c("div", {}, [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-trash fa-lg cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteMapping(props.row.id)
                                        }
                                      }
                                    })
                                  ])
                                }
                              }
                            ])
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "custom-search",
                                attrs: { slot: "beforeFilter" },
                                slot: "beforeFilter"
                              },
                              [
                                _c(
                                  "b-form",
                                  { attrs: { inline: "" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "btn grey btn-import-form m__r--5",
                                        on: {
                                          click: function($event) {
                                            _vm.isModalAppOpen(true)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-plus fa-lg"
                                        }),
                                        _vm._v(" Add\n                ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form",
                                      {
                                        attrs: { inline: "" },
                                        on: {
                                          keypress: function($event) {
                                            if (
                                              !("button" in $event) &&
                                              $event.keyCode !== 13
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            _vm.filter(_vm.filter_data)
                                          }
                                        }
                                      },
                                      [
                                        _c("j-select", {
                                          staticClass: "m__r--5",
                                          attrs: {
                                            options: _vm.options_search,
                                            placeholder: "Filter By"
                                          },
                                          model: {
                                            value: _vm.select_type,
                                            callback: function($$v) {
                                              _vm.select_type = $$v
                                            },
                                            expression: "select_type"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("b-form-input", {
                                          staticStyle: {
                                            width: "250px",
                                            height: "35px"
                                          },
                                          attrs: { placeholder: "Search" },
                                          model: {
                                            value: _vm.filter_data,
                                            callback: function($$v) {
                                              _vm.filter_data = $$v
                                            },
                                            expression: "filter_data"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.load_first ? _c("jLoadingTable") : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "configPopoverRef",
          attrs: {
            show: _vm.configPopoverShow,
            target: "configPopover",
            container: "studio-page-header",
            placement: "left"
          },
          on: {
            "update:show": function($event) {
              _vm.configPopoverShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-ui-opt", on: { click: _vm.deleteApps } },
            [
              _vm._v(
                "\n      Delete " +
                  _vm._s(_vm.modeDetail === "group" ? "Group" : "Application") +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _vm.modeDetail === "application"
            ? _c(
                "div",
                { staticClass: "form-ui-opt", on: { click: _vm.goToV2 } },
                [_vm._v("\n      Try New UI\n    ")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appModal",
          staticClass: "mod-form modal-app-type",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("j-modal-mapping-apps-group", {
            on: {
              "modal-open": _vm.isModalAppOpen,
              "data-created": _vm.getGroupApplicationList
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "btn-action-experience display-inline pull-right" },
      [
        _c("i", {
          staticClass:
            "fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10 m__l--20",
          attrs: { id: "configPopover" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "row-pages", attrs: { id: "pageCreate" } },
      [
        _c("i", { staticClass: "fa fa-plus" }),
        _vm._v("\n            Add Menu\n          ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bd0b730", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bd0b730","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/jApplicationDetail.vue
// module id = null
// module chunks = 